export const timeDataTable = 'timeData';
export const dayOffsTable = 'dayOffs';
export const userDataTable = 'userData';
export const vacationRequestsTable = 'vacationRequests';
export const userRolesTable = 'userRoles';
export const performanceReviewsTable = 'performanceReviews';
export const exchangeRateTable = 'exchangeRate';
